<script setup>
import { useQuery } from '@vue/apollo-composable';
import axios from 'axios';
import { BOverlay, BProgress } from 'bootstrap-vue-next';
import { ref, computed, onMounted } from 'vue';

import ErrorState from '~/common/components/ErrorState.vue';
import MarkdownRenderer from '~/common/components/MarkdownRenderer.vue';
import { UntriagedIssuesQueryDocument } from '~/graphql/types';

import aboutMarkdown from './labelathon-page/AboutSection.md?raw';
import DetailsSection from './labelathon-page/DetailsSection.vue';
import LabelSection from './labelathon-page/LabelSection.vue';
import LeaderboardSection from './labelathon-page/LeaderboardSection.vue';

const OLD_ISSUE_COUNT = 4750;
const INITIAL_ISSUE_COUNT = OLD_ISSUE_COUNT + 2820;

const { loading: queryLoading, refetch, result } = useQuery(UntriagedIssuesQueryDocument);
const issues = computed(() => result.value?.project.issues || { count: 0 });

const loading = ref(true);
const data = ref([]);
const key = ref(Math.random());
const error = ref(null);

const fetchData = async () => {
  loading.value = true;
  error.value = null;
  try {
    const response = await axios.get('/api/v1/hackathons/label_count');
    data.value = response.data;
  } catch (e) {
    error.value = e;
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  if (issues.value.nodes) {
    refetch();
    key.value = Math.random();
  }

  fetchData();
});
</script>

<template>
  <ErrorState v-if="error" />
  <template v-else>
    <MarkdownRenderer :markdown-content="aboutMarkdown" />
    <div class="mb-4">
      <BOverlay :show="issues.nodes == null">
        <BProgress
          striped
          show-progress
          :value="INITIAL_ISSUE_COUNT - issues.count"
          :max="INITIAL_ISSUE_COUNT"
          class="mb-2"
          height="20px"
        />
      </BOverlay>
      {{ INITIAL_ISSUE_COUNT - issues.count }} issues labeled of the {{ INITIAL_ISSUE_COUNT }} target!
    </div>
    <DetailsSection />
    <BOverlay :show="queryLoading">
      <LabelSection
        :key="key"
        :issues="issues.nodes || []"
      />
    </BOverlay>
    <LeaderboardSection
      :loading="loading"
      :user-counts="data"
    />
  </template>
</template>
